var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowNextIcon = function SvgArrowNextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#0592AF"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.33 20.13 1.77 1.77L20 12l-9.9-9.9-1.77 1.77L16.46 12z"
  })));
};

export default SvgArrowNextIcon;